<template>
  <div class="payment-window-component">
    <s-tabs disabled>
      <s-tab name="Типы оплаты" :selected="currentPaymentTab === 'paymentTypes'">
        <h1 class="step-title font-weight-regular">
          Укажите тип оплаты:
        </h1>
        <div class="button-group d-flex justify-between">
          <v-row dense class="justify-space-between">
            <v-col sm="5">
              <v-btn
                class="button button-back"
                width="100%"
                color="#F1F3F6"
                @click="stepBack"
              >
                <font-awesome-icon icon="chevron-left" />
                Вернуться назад
              </v-btn>
            </v-col>
            <v-col sm="5">
              <v-btn
                class="button button-apply"
                width="100%"
                color="#F1F3F6"
                @click="changePayment"
              >
                <font-awesome-icon icon="check" />
                Подтвердить тип оплаты
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <div class="pay-types-section">
          <v-row dense class="justify-space-between">
            <v-col sm="5">
              <v-btn-toggle
                v-model="currentPayType"
                dense
                group
                mandatory
                class="d-block"
              >
                <v-btn
                  v-if="terminalPaymentAvailable"
                  value="terminal"
                  class="button button-pay-type"
                  block
                  dark
                >
                  {{ terminalPaymentLabel }}
                </v-btn>

                <template v-if="isSourceAggregator">
                  <v-btn
                    value="aggregator_online"
                    class="button button-pay-type"
                    block
                    dark
                  >
                    Оплачен онлайн в
                    <template v-if="isSourceDeliveryClub">
                      &nbsp;"Delivery Club"
                    </template>
                    <template v-else-if="isSourceYandex">
                      &nbsp;"Яндекс.Еда"
                    </template>
                  </v-btn>
                </template>

                <template v-else>
                  <v-btn
                    v-if="cashPaymentAvailable"
                    value="cash"
                    class="button button-pay-type"
                    block
                    dark
                  >
                    {{ cashPaymentLabel }}
                  </v-btn>
                  <v-btn
                    v-if="onlinePaymentAvailable"
                    value="online"
                    class="button button-pay-type"
                    block
                    dark
                  >
                    Онлайн-оплата
                  </v-btn>
                </template>
              </v-btn-toggle>
            </v-col>

            <v-col sm="5" class="pay-details-col">
              <sliding-switch
                v-if="showPaymentModes"
                v-model="paymentMode"
                :items="paymentModeItems"
                class="payment-modes"
              />
              <div v-if="showPaymentModes && disabledModeHint" class="payment-modes-hint">
                <font-awesome-icon icon="info-circle" />
                {{ disabledModeHint }}
              </div>

              <!--              <div v-if="currentPayType === 'terminal'" class="card-section">
                <payment-type-icons />
              </div>-->

              <div v-if="showCashCalculator" class="cash-section">
                <span class="d-block label">С какой суммы подготовить сдачу?</span>
                <cash-calculator v-model="amount" hide-increment-decrement />
                <!-- <v-row class="amount-field">
                  <v-col sm="6">
                    <v-text-field
                      v-model.number="amount"
                      hide-details="auto"
                      class="text-field"
                      type="number"
                      flat
                      solo
                      @keydown="clearAmountCount"
                    />
                  </v-col>
                  <v-col sm="6">
                    <v-btn class="button button-clear" block @click="clearAmount">
                      <font-awesome-icon icon="times" />
                      Очистить
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="suggestions">
                  <v-col v-for="(item, i) in amounts" :key="i" sm="6">
                    <v-badge
                      class="fullwidth"
                      :content="item.count"
                      :color="item.count ? '#ff9100' : 'transparent'"
                    >
                      <v-btn class="button" block @click="setAmount(item.amount)">
                        {{ item.amount | amountStringWithCurrency }}
                      </v-btn>
                    </v-badge>
                  </v-col>
                </v-row> -->
              </div>

              <div v-if="currentPayType === 'online'" class="preorder-section">
                <span class="d-block label">
                  Оплата заказа возможна на сайте или в мобильном приложении в Личном кабинете на вкладке  заказы  после оформления
                </span>
                <template v-if="needClientEmail">
                  <span class="d-block email-label">У клиента не указан email - для онлайн-оплаты он обязателен:</span>
                  <v-text-field
                    ref="clientEmailField"
                    v-model="clientEmail"
                    hide-details="auto"
                    class="text-field email-field"
                    placeholder="Email клиента"
                    type="email"
                    flat
                    solo
                    :rules="clientEmailRules"
                  />
                </template>
                <!--                <v-text-field
                  v-model="phone"
                  v-mask="'+7 (###) ###-##-##'"
                  hide-details="auto"
                  class="text-field"
                  flat
                  solo
                />-->
                <div v-if="false" class="success-sending d-flex align-center">
                  <div class="status d-flex align-center justify-center">
                    <font-awesome-icon icon="check" />
                  </div>
                  <span class="status-text">Ссылка на оплату отправлена на телефон клиента!</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </s-tab>

      <s-tab v-if="!isNewOrderPage" name="Оплачено" :selected="currentPaymentTab === 'paid'">
        <template v-if="!isNewOrderPage">
          <h1 class="step-title font-weight-regular">
          </h1>

          <div class="button-group d-flex justify-between">
            <v-row v-if="false" dense class="justify-space-between">
              <v-col sm="5">
                <v-btn
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                  @click="stepBack"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
              <!--          <v-col sm="5">
                  <v-btn class="button button-apply" width="100%" color="#F1F3F6">
                    <font-awesome-icon icon="check" />
                    Сохранить адрес
                  </v-btn>
                </v-col>-->
            </v-row>
            <v-col md="6" offset-md="3">
              <div class="paid-section">
                <div class="order-code">
                  Заказ № {{ order.code }}
                </div>
                <div class="date">
                  от {{ order.createdAt }}
                </div>
                <div class="paid-status">
                  Оплачено
                </div>
                <div class="actions">
                  <v-btn
                    color="red"
                    dark
                    class="button font-weight-medium"
                    @click="showCancelDialog = true"
                  >
                    <font-awesome-icon icon="times" />
                    Отменить заказ и оплату
                  </v-btn>
                </div>

                <!--                <div class="pay-desc text-center">
                  <p>При отмене заказа, клиенту вернутся денежные средства!</p>
                  <p>Возврат денег обычно занимает от нескольких минут до нескольких часов в зависимости от Банка</p>
                </div>-->
              </div>
            </v-col>
            <v-row>
            </v-row>
          </div>
        </template>
      </s-tab>
    </s-tabs>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import PickupPoint from '@/components/order-processing/order-components/second-step/PickupPoint.vue'
  import VKeyboard from '@/components/order-processing/new-order/keyboard/Keyboard.vue'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import STabs from '@/components/ui/tabs/STabs.vue'
  import STab from '@/components/ui/tabs/STab.vue'
  import PaymentTypeIcons from '@/components/order-processing/order-components/payment/PaymentTypeIcons.vue'
  import orderEdit from '@/mixins/order-edit'
  import BasketSource from '@/models/enums/BasketSource'
  import CashCalculator from './CashCalculator.vue'
  import SlidingSwitch from '@/components/ui/buttons/SlidingSwitch.vue'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import {
    availablePaymentModes,
    acceptedPaymentTypes,
    enabledPaymentModes,
    paymentModeItems,
    disabledModeHint,
  } from '@/util/payment-mode'

  export default {
    name: 'PaymentWindow',
    components: {
      PaymentTypeIcons,
      STab,
      STabs,
      PickupPoint,
      VKeyboard,
      CashCalculator,
      SlidingSwitch,
    },
    mixins: [orderEdit],
    data () {
      return {
        amounts: [
          { amount: 5000, count: 0 },
          { amount: 2000, count: 0 },
          { amount: 1000, count: 0 },
          { amount: 500, count: 0 },
          { amount: 100, count: 0 },
        ],
        showAddressForm: false,
        currentPayType: 'card',
        phone: '',
        clientEmail: '',
        amount: 0,
        currentPaymentTab: 'paymentTypes',
        showCancelDialog: false,
        paymentMode: null,
      }
    },
    computed: {
      ...mapState({
        // currentPaymentTab: (state) => state.newOrder.currentPaymentTab,
        client: (state) => state.clients.clientsSingle,
        basket: (state) => state.baskets.basket,
        orderPaymentMode: (state) => state.newOrder.paymentMode,
      }),
      ...mapGetters({
        isSourceAggregator: 'baskets/isSourceAggregator',
        isSourceYandex: 'baskets/isSourceYandex',
        isSourceDeliveryClub: 'baskets/isSourceDeliveryClub',
        isNewOrderPage: 'app/isNewOrderPage',
        isCallCenterUser: 'auth/isCallCenterUser',
      }),
      // бэк для CRM добавил к доставке методы точки; оставляем те, что принимают хотя бы в одном доступном режиме
      availableTypes () {
        return acceptedPaymentTypes(this.basket, this.availablePaymentModes)
      },
      onlinePaymentAvailable () {
        return this.availableTypes.includes(PaymentType.Online)
      },
      cashPaymentAvailable () {
        return this.availableTypes.includes(PaymentType.Cash)
      },
      terminalPaymentAvailable () {
        return this.availableTypes.includes(PaymentType.Terminal)
      },
      onlinePaymentLabel () {
        return PaymentType.getName(PaymentType.Online, this.basket?.deliveryType)
      },
      terminalPaymentLabel () {
        return PaymentType.getPickLabel(PaymentType.Terminal, this.basket.deliveryType)
      },
      cashPaymentLabel () {
        return PaymentType.getPickLabel(PaymentType.Cash, this.basket.deliveryType)
      },
      availablePaymentModes () {
        return availablePaymentModes({
          deliveryType: this.basket.deliveryType,
          canPayNow: this.userCan(CRMPermission.MakeOrderPayment),
          isCallCenter: this.isCallCenterUser,
        })
      },
      enabledPaymentModes () {
        return enabledPaymentModes(this.basket, this.availablePaymentModes, this.currentPayType)
      },
      defaultPaymentMode () {
        return this.enabledPaymentModes[0] || this.availablePaymentModes[0]
      },
      paymentModeItems () {
        return paymentModeItems(this.basket, this.availablePaymentModes, this.currentPayType)
      },
      disabledModeHint () {
        return disabledModeHint(this.basket, this.availablePaymentModes, this.currentPayType)
      },
      // онлайн платит клиент по ссылке - выбирать нечего; одна позиция без права на оплату - тоже
      showPaymentModes () {
        return this.isNewOrderPage &&
          this.basket.basketSource === BasketSource.Crm &&
          this.currentPayType !== PaymentType.Online &&
          this.availablePaymentModes.length > 1
      },
      // для онлайн режим ставит бэк; скрытая единственная позиция уходит как есть
      paymentModeToSend () {
        return this.currentPayType === PaymentType.Online ? null : this.paymentMode
      },
      // при «оплата позже» денег сейчас не берут - сдачу считать нечего
      showCashCalculator () {
        return this.currentPayType === PaymentType.Cash && this.paymentMode !== PaymentMode.PayLater
      },
      // без email клиент не попадёт в личный кабинет - онлайн-оплату не подтверждаем
      needClientEmail () {
        return this.currentPayType === PaymentType.Online && !this.knownClientEmail
      },
      knownClientEmail () {
        return this.basket?.client?.email || this.client?.email || null
      },
      clientEmailRules () {
        return [
          v => !!(v && v.trim()) || 'Email обязателен для онлайн-оплаты',
          v => (!v || !!v.match(/.+@.+\..+/)) || 'Введите корректный email',
        ]
      },
      isClientEmailValid () {
        return this.clientEmailRules.every(rule => rule(this.clientEmail) === true)
      },
      // бэк сортирует список с онлайном первым (приоритет сайта) - автоселект его не предлагает,
      // онлайн-оплату оператор выбирает осознанно
      defaultPayType () {
        return this.availableTypes.find(type => type !== PaymentType.Online) || this.availableTypes[0]
      },
    },
    watch: {
      availableTypes (types) {
        if (types.length && !types.includes(this.currentPayType)) {
          this.currentPayType = this.defaultPayType
        }
      },
      enabledPaymentModes (modes) {
        if (!modes.includes(this.paymentMode)) {
          this.paymentMode = this.defaultPaymentMode
        }
      },
    },
    mounted () {
      this.amount = this.basket.clientMoney || 0
      this.currentPayType = this.basket.paymentType || 'card'
      // тип корзины могли выключить в настройках - кнопки нет, а выбор остался бы невидимым
      if (this.availableTypes.length && !this.availableTypes.includes(this.currentPayType)) {
        this.currentPayType = this.defaultPayType
      }
      // режим не хранится в корзине - живёт в сторе до оформления; без восстановления
      // возврат на шаг молча сбрасывал выбор оператора на режим по умолчанию
      this.paymentMode = this.enabledPaymentModes.includes(this.orderPaymentMode)
        ? this.orderPaymentMode
        : this.defaultPaymentMode
      this.$store.commit('newOrder/setPaymentMode', this.paymentModeToSend)
    },
    methods: {
      changePayment () {
        const data = {}
        const id = this.basket.id
        // режим применяем вместе с типом - иначе заказ мог уйти с новым режимом и старым типом
        const paymentMode = this.paymentModeToSend

        switch (this.currentPayType) {
          case PaymentType.Cash:
            data.paymentType = PaymentType.Cash
            data.clientMoney = this.amount
            break

          case PaymentType.Online:
            // email клиенту нужен для входа в кабинет, где он оплатит заказ - бэк сохранит его этим же запросом
            if (this.needClientEmail) {
              if (!this.isClientEmailValid) {
                if (this.$refs.clientEmailField) {
                  this.$refs.clientEmailField.validate(true)
                }
                this.showErrorMessage('Email клиента обязателен для онлайн-оплаты')
                return
              }
              data.clientEmail = this.clientEmail.trim()
            }
            data.paymentType = PaymentType.Online
            /* if (this.phone) {
              this.updatePaymentPhone()
            } */
            break

          default:
            data.paymentType = this.currentPayType
        }

        // бэк по режиму решает, каким набором методов проверять тип
        if (paymentMode) {
          data.paymentMode = paymentMode
        }

        this.$store
          .dispatch('baskets/updateBasketPayment', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit('newOrder/setPaymentMode', paymentMode)
              this.showSuccessMessage('Тип оплаты обновлен')
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
              this.$store.commit('newOrder/toggleResultWindow', true)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      updatePaymentPhone () {
        const data = {
          paymentPhone: this.phone,
        }
        const id = this.basket.id

        this.$store.dispatch('baskets/updateBasket', { data, id })
          .then((res) => {
            if (res.status !== 200) {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      setAmount (amount) {
        this.$nextTick(() => {
          if (this.amount) {
            this.amount = parseInt(this.amount)
          }
          this.amount += parseInt(amount)
          const currentAmount = this.amounts.find(item => item.amount === amount)
          currentAmount.count++
        })
      },
      clearAmount () {
        this.amount = 0
        this.$nextTick(() => {
          this.amount = 0
          this.clearAmountCount()
        })
      },
      clearAmountCount () {
        this.amounts.forEach(item => {
          item.count = 0
        })
      },
      stepBack () {
        this.$store.commit('newOrder/setStep', 1)
      },
      setTab (tab) {
        this.currentTab = tab
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-window-component {

  background-color: #fafafa;
  .media-xl({
    padding-top: 30px;
  });

  .tabs {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      flex: 1;
      outline: none;
      font-size: 24px;
      line-height: 21px;
      border-radius: 14px 14px 0 0;
      height: 57px;
      cursor: default;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }

  .button {
    height: 80px;
    box-shadow: 0 3px 6px #00000029 !important;
    background-color: @color-secondary !important;
    border-radius: 10px !important;
    font-size: 15px;
    line-height: 20px;
    color: #000000;
    font-weight: 500;
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 2px solid @color-error;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .step-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 33px;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .pay-types-section {
    // Уже 1300px правая колонка (способ оплаты, калькулятор сдачи) - половина
    // ряда вместо 5/12: в узкой переключателю и кнопкам сумм тесно
    @media (max-width: 1299px) {
      .pay-details-col {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    .payment-icons {
      .payment-icon {
        margin-top: 13px;
        margin-bottom: 15px;
        margin-right: 25px;
      }
    }
    ::v-deep {
      .button-pay-type {
        &.v-item--active {
          background-color: @color-primary !important;
          color: #ffffff;
        }
      }
    }
    .button-pay-type {
      margin: 0 0 20px;
      &:last-child {
        margin-bottom: 0;
      }
      &:before {
        display: none;
      }
    }
  }

  .new-address-section {
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 25px;
    }

    .button-add {
      background-color: @color-primary !important;
      height: 94px;

      svg {
        width: 20px;
        height: 20px;
        margin-bottom: 12px;
      }
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .card-section {
  }

  .cash-section {
    .label {
      font-size: 24px;
      line-height: 1;
      margin-bottom: 33px;
    }

    // Уже 1300px блок сдачи пропорционально меньше (примерно на 18%), чтобы все
    // ряды сумм помещались на экран. Сам калькулятор общий с другими окнами,
    // поэтому размеры задаются отсюда. !important - у поля и кнопки «Очистить»
    // высота стоит инлайном от пропа height
    @media (max-width: 1299px) {
      .label {
        font-size: 20px;
        margin-bottom: 20px;
      }

      ::v-deep .change-calculator {
        .text-field .v-input__slot {
          height: 88px !important;

          input {
            font-size: 22px;
          }
        }

        .button {
          height: 66px;
          font-size: 15px;
        }

        .button.button-clear {
          height: 88px !important;
          font-size: 14px;
        }
      }
    }

    .amount-field {
      margin-bottom: 32px;

      .button-clear {
        svg {
          margin-right: 13px;
          .fill-svg(@color-error);
        }
      }
    }
  }

  .payment-modes {
    margin-bottom: 24px;
  }

  .payment-modes-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: -12px 0 24px;
    font-size: 18px;
    line-height: 1.35;
    color: @color-btn-dark-grey;

    svg {
      flex-shrink: 0;
      .fill-svg(@color-primary);
    }
  }

  .preorder-section {
    .label {
      font-size: 24px;
      line-height: 1;
      margin-bottom: 33px;
    }

    .email-label {
      font-size: 18px;
      line-height: 1.3;
      margin-bottom: 15px;
    }

    .email-field {
      margin-bottom: 20px;

      ::v-deep {
        input {
          font-size: 20px;
        }
      }
    }

    .success-sending {
      padding: 12px 13px;
      margin-top: 20px;
      margin-bottom: 12px;
      background-color: #e6f2e6;
      border-radius: 10px;

      .status {
        flex-shrink: 0;
        background-color: @color-success;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        margin-right: 44px;

        svg {
          width: 23px;
          height: 23px;
          .fill-svg(#ffffff);
        }
      }
    }
  }
}
</style>
